import EmblaCarousel from 'embla-carousel'
import AutoPlay from 'embla-carousel-autoplay'
import Fade from 'embla-carousel-fade'

$(document).ready(function() {
  $('.dropdown-button-section-teaser').click(function() {
    $(this).next('.tabs-nav-section-teaser').toggleClass('active');
    $(this).toggleClass('rotate-icon-section-teaser');
  });

  if ($('.embla-sections').length) {
    const emblaNodeSections = document.querySelector('.embla-sections');
    const optionsSections = { loop: true };
    const emblaApiSections = EmblaCarousel(emblaNodeSections, optionsSections, [AutoPlay({ playOnInit: true, delay: 6000 }), Fade()]);
  
    emblaApiSections.slideNodes();
  }
});